import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useVWO = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.VWO) {
      window.VWO.push(['trackPage']);
    }
  }, [location]);
}